import { setupAccordion } from '../../src/js/utils/accordion';

const init = (): void => setupAccordion('.curriculum__item', '.curriculum__panel');

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
